import 'cross-fetch/polyfill';
import { CUSTOM_EXPORT_FORM } from '@engine/actions/action-types';
/**
 * Action Creators for Custom Export Modal
 */

export var resetForm = function resetForm(preference) {
  return {
    type: CUSTOM_EXPORT_FORM(preference).resetForm
  };
};
export var handleResponse = function handleResponse(preference, data) {
  return {
    type: CUSTOM_EXPORT_FORM(preference).responseReceive,
    data: data
  };
};
export var submitFail = function submitFail(preference) {
  return {
    type: CUSTOM_EXPORT_FORM(preference).requestFail
  };
};
export var submitRequest = function submitRequest(preference) {
  return {
    type: CUSTOM_EXPORT_FORM(preference).exportRequest
  };
};
/**
 * Submit Form
 */

export function submitForm(url, preference) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'POST';
  return function (dispatch, getState) {
    dispatch(submitRequest(preference));
    var fields = getState()["columns-for-".concat(preference)].selectedFields;
    var formData = {
      authenticity_token: window.CSRF,
      custom_export: fields
    };
    return fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(handleResponse(preference, json));
    })["catch"](function () {
      return dispatch(submitFail(preference));
    });
  };
}